import React from 'react';
import { get } from 'lodash/fp';
import PropTypes from 'prop-types';
import { Table } from 'rsuite';

const { Cell } = Table;

const SelectionCell = ({ options, dataKey, rowData, ...props }) => {
  const value = get(dataKey, rowData);
  return (
    <Cell {...props}>{value ? `${value}: ${get(value, options)}` : ''}</Cell>
  );
};

SelectionCell.propTypes = {
  dataKey: PropTypes.string.isRequired,
  rowData: PropTypes.shape({}),
  options: PropTypes.oneOfType([
    PropTypes.shape({}),
    PropTypes.arrayOf(PropTypes.string)
  ]).isRequired
};

SelectionCell.defaultProps = {
  rowData: null
};

export default SelectionCell;
